var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVirtualTutorialicon = function SvgVirtualTutorialicon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1.5em",
    height: "1.5em",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M21 16.26c0 .225-.045.45-.135.657a1.8 1.8 0 0 1-.369.558 2 2 0 0 1-.558.369 1.7 1.7 0 0 1-.666.126 13.7 13.7 0 0 0-3.033.288 8.4 8.4 0 0 0-3.339 1.143V5.982a10 10 0 0 1 3.114-.9 15.7 15.7 0 0 1 3.339-.297c.446.025.866.222 1.17.549.297.317.462.735.459 1.17zM11.1 5.982v13.419a8.3 8.3 0 0 0-3.285-1.143 14.6 14.6 0 0 0-3.087-.288 1.7 1.7 0 0 1-.666-.126 2 2 0 0 1-.558-.369 1.6 1.6 0 0 1-.369-.558A1.6 1.6 0 0 1 3 16.26V6.45a1.71 1.71 0 0 1 1.602-1.701 15.3 15.3 0 0 1 3.411.297 9.6 9.6 0 0 1 3.087.936"
  })));
};
export default SvgVirtualTutorialicon;